var React = require('react');

function BigChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.5 28c-.4 0-.8-.1-1.1-.4-.6-.6-.6-1.5 0-2.1L11.9 14 .4 2.6C-.1 2-.1 1 .4.4 1-.1 2-.1 2.6.4l12.5 12.5c.3.3.4.7.4 1.1s-.2.8-.4 1.1L2.5 27.6c-.3.3-.7.4-1 .4z"}));
}

BigChevronRight.defaultProps = {"width":"16","height":"28","viewBox":"0 0 16 28"};

module.exports = BigChevronRight;

BigChevronRight.default = BigChevronRight;
